import { lazy } from "react";
import { enumPermisosBancoW } from "./enumPermisosBancoW";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../../components/Base/AppIcons"));

/**
 * Corresponsalia BancoW
 */
const CorresponsaliaBancoW = lazy(() => import("./CorresponsaliaBancoW"));


const RetiroBancoW = lazy(() => import("./Views/TrxCuentas/Retiro"));

const PagoProductosPropiosBancoW = lazy(() => import("./Views/TrxCuentas/PagoProductosPropios"));

export const listPermissionsBancoW = Object.values(enumPermisosBancoW);

const rutasBancoW = {
  //corresponsaliaBancoW
  link: "/corresponsalia/corresponsalia-BancoW",
  label: <AppIcons Logo={"BANCO_W"} name="Corresponsalía Banco W" />,
  component: CorresponsaliaBancoW,
  permission: listPermissionsBancoW,
  subRoutes: [
    {
      link: "/corresponsalia/corresponsalia-BancoW/retiro",
      label: <AppIcons Logo={"MARKETPLACE"} name="Retiro Con OTP" />,
      component: RetiroBancoW,
      permission: [enumPermisosBancoW.RETIRO_BANCO_W],
    },
    {
      link: "/corresponsalia/corresponsalia-BancoW/pago-productos-propios",
      label: <AppIcons Logo={"MARKETPLACE"} name="Pago de Productos Propios" />,
      component: PagoProductosPropiosBancoW,
      permission: [enumPermisosBancoW.PAGO_PRODUCTOS_PROPIOS_BANCO_W],
    },
  ],
};

export default rutasBancoW;
